import { isEmptyArray } from '@dte/otw-utils-core/src/objects/isEmpty';
import type { ReportAnswers } from '../../../../report/CustomerReport';
import { getSelectedAnswerStrings } from '../../../../report/getQuestion';
import { ReportQuestion } from '../../../../report/questions/ReportQuestion';
import type { PremiseDataDocument } from '../../../interfaces/containers/premises/PremiseData';
import { hasActiveElectric } from './hasActiveElectric';

export function isPowerIssue(answers: ReportAnswers, masterData: PremiseDataDocument | undefined): boolean {
	const activeElectric = hasActiveElectric(masterData);
	if (!activeElectric) {
		return false;
	}

	const powerIssues = getSelectedAnswerStrings(answers, ReportQuestion.PowerIssue);
	if (isEmptyArray(powerIssues)) {
		return false;
	}

	return true;
}
